import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { supplierActions } from "../sagas/supplierSlice";

export function useSupplierFetch() {
  const dispatch = useDispatch();
  const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);

  useEffect(() => {
    dispatch(supplierActions.search({ query: "" }));
  }, [dispatch]);

  const fournisseurOptions = !suppliersLoading ? suppliers?.map(sup => ({
    solde: sup.solde,
    totalDebit: sup.totalDebit,
    totalCredit: sup.totalCredit,
    value: sup.id,
    label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom}` : sup.entreprise,
  })) : [];

  return { suppliers, suppliersLoading, fournisseurOptions };
}
